import { createFileRoute, useParams } from '@tanstack/react-router';

import { HomeworksTab } from '@/views/admin/courses/tabs/homeworks-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/homeworks')({
  component: HomeworksRoute,
});

function HomeworksRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/homeworks' });
  return <HomeworksTab id={id} />;
}
